// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewSensorySessionId } from './BrewSensorySession';
import { brewBatchId } from './BrewBatch';
import { brewSampleId } from './BrewSample';
import { z } from 'zod';
export const brewSensorySessionSampleId = (z.number());
export const brewSensorySessionSample = z.object({
    id: brewSensorySessionSampleId,
    brew_sensory_session_id: brewSensorySessionId,
    brew_batch_id: brewBatchId.nullable(),
    brew_sample_id: brewSampleId.nullable(),
    blinding_code: z.number(),
    is_reference: z.boolean(),
    display_order: z.number(),
    created_at: z.date(),
});
export const brewSensorySessionSampleInitializer = z.object({
    id: brewSensorySessionSampleId.optional(),
    brew_sensory_session_id: brewSensorySessionId,
    brew_batch_id: brewBatchId.optional().nullable(),
    brew_sample_id: brewSampleId.optional().nullable(),
    blinding_code: z.number(),
    is_reference: z.boolean().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
});
export const brewSensorySessionSampleMutator = z.object({
    id: brewSensorySessionSampleId.optional(),
    brew_sensory_session_id: brewSensorySessionId.optional(),
    brew_batch_id: brewBatchId.optional().nullable(),
    brew_sample_id: brewSampleId.optional().nullable(),
    blinding_code: z.number().optional(),
    is_reference: z.boolean().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=BrewSensorySessionSample.js.map